module.exports = __webpack_public_path__ + "img/Cross.118d2b71.svg";